import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import User from '../../../components/user/user/listar';


function ListUserScreen () {
    return (
        <Fragment>
            <Head titulo="Listagem de Usuário | Departamento de TI" />
            <Header />
            <User />
            <Footer />
        </Fragment>
    );
}

export default ListUserScreen;